import React, { Children } from 'react'
import { gsap, ScrollTrigger, Linear } from 'gsap/all'

gsap.registerPlugin(ScrollTrigger)

class AudioWrapper extends React.Component {
    constructor(props) {
        super(props)

        this.domRef = React.createRef()
    }

    componentDidMount() {
        const audio = new Audio(this.props.audioRef)
        audio.volume = 0
        audio.loop = true
        let animation = { volume: 0 }

        document.addEventListener('allimagesloaded', () => {
            let animationTimeline = gsap.timeline({
                ease: Linear.easeNone,
                scrollTrigger: {
                    toggleClass: 'audio-playing',
                    trigger: this.domRef.current,
                    toggleActions: 'play reverse play reverse',
                    start: 'top bottom',
                    end: 'bottom top',
                    scrub: true
                }
            })
                .eventCallback('onStart', () => { if (audio.paused) audio.play() })
                .eventCallback('onComplete', () => { if (!audio.paused) audio.pause() })
                .eventCallback('onUpdate', () => audio.volume = animation.volume)

            animationTimeline
                .to(animation, {
                    volume: 1,
                    
                })
                .to(animation, {
                    volume: 0,
                    
                })
        })
    }

    render() {
        return (
            <div className="audio-wrapper" ref={this.domRef}>
                {this.props.children}
            </div>
        )
    }
}

export default AudioWrapper